export function BodyMedium({children, color, fontWeight = 400}) {
    return (
        <span style={{
            lineHeight: '1.05em',
            fontFamily: 'Open Sans',
            fontSize: '0.875em',
            display: 'block',
            color,
            fontWeight,
        }}>{children}</span>
    );
}
